import * as React from 'react';
import { FormControl } from 'native-base';
import { Input } from './Input';

export const InputWithLabel = (props) => {
  const { label, ...inputProps } = props;

  return (
    <>
      <FormControl.Label
        style={{
          marginBottom: 8,
          marginTop: 16,
        }}
      >
        {label}
      </FormControl.Label>
      <Input {...inputProps} />
    </>
  );
};
